
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const teamMembers = [
    { name: "Alex Johnson", email: "alex@neon.garden", role: "Venue Admin", avatar: "/placeholder.svg", venue: "Neon Garden" },
    { name: "Maria Garcia", email: "maria@velvet.underground", role: "Event Planner", avatar: "/placeholder.svg", venue: "The Velvet Underground" },
    { name: "David Smith", email: "david@warehouse.proj", role: "Cashier / Door Staff", avatar: "/placeholder.svg", venue: "The Warehouse Project" },
    { name: "Emily White", email: "emily@rooftop.rhythms", role: "Venue Admin", avatar: "/placeholder.svg", venue: "Rooftop Rhythms" },
];

const TeamAccess = () => {
    return (
        <Card className="bg-white/5 border-white/20 text-white">
            <CardHeader>
                <CardTitle className="flex justify-between items-center">
                    👥 Team & Role Access
                    <Button variant="outline" className="bg-transparent hover:bg-white/10 border-white/30 text-white hover:text-white">Invite Member</Button>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow className="border-white/20 hover:bg-white/10">
                            <TableHead className="text-white">User</TableHead>
                            <TableHead className="text-white hidden md:table-cell">Role</TableHead>
                            <TableHead className="text-white hidden sm:table-cell">Assigned Venue</TableHead>
                            <TableHead className="text-white text-right">Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {teamMembers.map((member) => (
                            <TableRow key={member.email} className="border-white/20 hover:bg-white/10">
                                <TableCell>
                                    <div className="flex items-center gap-3">
                                        <Avatar>
                                            <AvatarImage src={member.avatar} />
                                            <AvatarFallback>{member.name.slice(0,2)}</AvatarFallback>
                                        </Avatar>
                                        <div>
                                            <div className="font-medium">{member.name}</div>
                                            <div className="text-sm text-gray-400">{member.email}</div>
                                        </div>
                                    </div>
                                </TableCell>
                                <TableCell className="hidden md:table-cell">
                                    <Badge variant="outline" className="border-white/50 text-white">{member.role}</Badge>
                                </TableCell>
                                <TableCell className="hidden sm:table-cell">{member.venue}</TableCell>
                                <TableCell className="text-right">
                                    <Button variant="ghost" size="sm" className="text-white hover:bg-white/10 hover:text-white">Edit</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

export default TeamAccess;
